import { supabase } from '../config/supabase';

export async function adminRequest(action, values = {}) {
  const { data, error } = await supabase.functions.invoke('admin-users', { body: { action, ...values } });
  if (error) {
    let message = error.message;
    try { message = (await error.context.json()).error || message; } catch { /* Transport failure. */ }
    throw new Error(message);
  }
  if (data?.error) throw new Error(data.error);
  return data;
}

export async function requestPasswordReset(email) {
  // Use the canonical URL so email links also work on a different device.
  return supabase.auth.resetPasswordForEmail(email.trim(), { redirectTo: 'https://www.hestiadoors.com/admin/set-password' });
}
